import { Box, MobileStepper, Typography } from '@mui/material';
import React from 'react';
export const SmallScreenHeader = ({ step, currentStepLabel }) => {
    return (React.createElement(Box, { width: "100%", px: 2 },
        React.createElement(MobileStepper, { variant: "dots", steps: 4, position: "static", activeStep: step, sx: {
                maxWidth: 400,
                '& .MuiMobileStepper-dot': {
                    width: '40px',
                    height: '4px',
                    borderRadius: '40px',
                },
            }, nextButton: React.createElement(React.Fragment, null), backButton: React.createElement(React.Fragment, null) }),
        React.createElement(Typography, { mt: 1, pl: 1, color: "primary", fontSize: "0.9rem", fontWeight: 500 }, currentStepLabel)));
};
